import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { SHOP_TIRES } from '../../../../library/fitment/fitment-constants';
import FitmentShopTiresFlow from '../../../../components/fitment-shop-tires-flow/fitment-shop-tires-flow';

function VehicleLandingPageShopTires(props) {
  const { selectedFitment, textOverrides } = props;
  const [shopTiresViewState, setShopTiresViewState] = useState(
    SHOP_TIRES.LOADING
  );

  return (
    <FitmentShopTiresFlow
      fitment={selectedFitment}
      setViewState={setShopTiresViewState}
      showTopBackLink={
        shopTiresViewState !== SHOP_TIRES.NEED_HELP_FINDING_TIRES &&
        shopTiresViewState !== SHOP_TIRES.WINTER_TIRES_OPTION &&
        shopTiresViewState !== SHOP_TIRES.LOADING
      }
      textOverrides={textOverrides}
      viewState={shopTiresViewState}
    />
  );
}

VehicleLandingPageShopTires.propTypes = {
  selectedFitment: PropTypes.object,
  textOverrides: PropTypes.object
};

export default VehicleLandingPageShopTires;
